// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "hr[data-v-c12226ea]{margin:.75rem -14px}", "",{"version":3,"sources":["webpack://./resources/client/modules/lead/sections/LeadBuyingInfo.vue"],"names":[],"mappings":"AAGA,oBACE,mBAFF","sourcesContent":["\n@import \"../../../styles/variables/variables\";\n\nhr {\n  margin: 0.75rem (-$modalGutter);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
